<template>
  <div id="app">
    <loading v-show="LOADING"></loading>
<!--    <router-view class="Router" ></router-view>-->
    <!--需要缓存组件-->
    <keep-alive>
      <!--router-view组件是一个 functional 组件，渲染路径匹配到的视图组件-->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!--不需要缓存组件-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { isWeixin } from 'utils/index'
import minBar from 'components/DownTab/DownTab'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import Loading from 'components/Loading/Loading'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  data () {
    return {
      keepAlive: 'main-keep-alive', // 需要缓存的页面 例如首页
      transitionName: 'slide-right', // 初始过渡动画方向,
      showMinTab: false
    }
  },
  computed: {
    // ...mapState(['name'])
    // ...mapState({
    //   name: state => (state.moduleA.text + "和" + state.moduleB.text)
    // })
    // ...mapGetters({
    //   name: '../store/moduleA/detail'  // 路径有问题
    // }),
    ...mapState([
      'LOADING'
    ])
  },
  methods: {
    // ...mapActions(['modifyName']),
    // modifyNameAction () {
    //   this.modifyName('bighone');
    // }
    // ...mapMutations(['setText']),
    // modifyNameAction () {
    //   this.setText()
    // }
    ...mapActions(['callAction']),
    modifyNameAction () {
      this.callAction();
    }
  },
  watch: {
    /**
     * 侦听路由的变化,控制底部tabbar的显示
     */
    $route (to, from) {
      // 切换动画
      let isBack = this.$router.isBack // 监听路由变化时的状态为前进还是后退
      // if (isBack) {
      //   this.transitionName = 'van-slide-left'
      // } else {
      //   this.transitionName = 'van-slide-right'
      // }
      if (isBack) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
      this.$router.isBack = false;
      if (to.path === '/homeHeader' || to.path === '/teacherIndex' || to.path === '/headerAttendance' || to.path === '/teacherAttendance' || to.path === '/headerHealth' || to.path === '/teacherHealth' || to.path === '/headerPersonal' || to.path === '/teacherPersonal') {
        this.showMinTab = true;
      } else {
        this.showMinTab = false
      }
    }
  },
  mounted () {
    console.log(this.$route);
    if (!isWeixin()) {
      /* 区分关闭和刷新，关闭退出登录 start */
      // window.onload = function () {
      //   if (!window.sessionStorage["ISlogin"]) {
      //     Cookies.remove("token");
      //     Cookies.remove("uid");
      //     location.reload(); // 不能省，强制跳到登陆页
      //     // this.$router.push({ path:'/userLogin'});
      //   } else {
      //     window.sessionStorage.removeItem("ISlogin");
      //   }
      // };
      // window.onunload = function () {
      //   window.sessionStorage["ISlogin"] = true;
      // };
      // window.onbeforeunload = function () {
      //   window.sessionStorage["ISlogin"] = true;
      // }
    }
  },
  components: {
    Loading,
    minBar
  }
}
</script>
<style lang="less">
  @import 'styles/index.less';
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    margin: auto;
    position: relative;

    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*.Router {*/
      /*position: fixed;*/
      /*left: 0;*/
      /*top: 0;*/
      /*width: 100%;*/
      /*height: 100%;*/
      /*transition: all .377s ease;*/
      /*will-change: transform;*/
      /*backface-visibility: hidden;*/
      /*perspective: 1000;*/
    /*}*/
    /*.slide-left-enter,*/
    /*.slide-right-leave-active {*/
      /*opacity: 0;*/
      /*transform: translate3d(-100%, 0, 0);*/
    /*}*/

    /*.slide-left-leave-active,*/
    /*.slide-right-enter {*/
      /*opacity: 0;*/
      /*transform: translate3d(100%, 0 ,0);*/
    /*}*/
  }
</style>
